import type { IconData } from '@stacksjs/iconify-core'

export const tiktok: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M17.045 20.667C10.564 21.117 5 25.736 5 32.815C5 39.545 10.393 45 17.045 45s12.046-5.455 12.046-12.185l-.348-15.19c3.027 2.336 7.862 3.748 12.336 3.974c.8.04 1.568-.323 1.755-1.103c.095-.397.166-.914.166-1.573s-.07-1.176-.166-1.573c-.187-.78-.956-1.118-1.754-1.198c-6.05-.605-11.747-5.5-12.561-11.28c-.104-.73-.513-1.405-1.228-1.591A8.8 8.8 0 0 0 25.076 3a8.8 8.8 0 0 0-2.218.281c-.713.186-1.139.856-1.156 1.594l-.642 27.94c0 2.243-1.797 4.062-4.015 4.062s-4.015-1.819-4.015-4.062c0-2.332 1.95-3.833 4.015-4.217\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tiktok
